// extracted by mini-css-extract-plugin
export var closeButton = "searchBar-module--closeButton--f418d";
export var div = "searchBar-module--div--751ce";
export var icon = "searchBar-module--icon--418cf";
export var input = "searchBar-module--input--277e8";
export var inputComputer = "searchBar-module--inputComputer--fbcf8";
export var inputComputerHome = "searchBar-module--inputComputerHome--fcef7";
export var inputMobile = "searchBar-module--inputMobile--c8b1b";
export var inputProductList = "searchBar-module--inputProductList--dca64";
export var inputTablet = "searchBar-module--inputTablet--d165a";
export var segment = "searchBar-module--segment--98459";
export var superHeader = "searchBar-module--superHeader--1af4f";